import { render, staticRenderFns } from "./CommercialsPanel.vue?vue&type=template&id=7399dfae&"
import script from "./CommercialsPanel.vue?vue&type=script&lang=js&"
export * from "./CommercialsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports